const state = {
  ActivityId: '', // 赛事ID
  matchInfo: {}, // 赛事设置详细信息
  prizeInfo: {}, // 赛事奖项设置信息
  matchBaseInfo: {}, // 赛事基本设置信息
  matchLinkModuleInfo: [], // 赛事环节设置信息
  matchSettingTimeline: [], // 赛事设置时间轴
  matchSignUpInfo: {}, // 赛事报名设置信息
  matchUseDefaultTheme: true, // 赛事报名设置默认主题
  matchMaterialInfo: {}, // 赛事材料设置信息
  materialUploadSettingList: [], // 赛事材料上传设置
  matchMaterialAttachmentInfo: [], // 赛事材料附件设置信息
  matchLiveInfo: {}, // 赛事现场设置信息
  matchLinkPackage: 'scene_materials', // 赛事环节套餐
  matchSignUpReviewSelected: false, // 报名审核
  matchMaterialReviewSelected: false, // 材料审核
  matchMaterialScoreSelected: false, // 材料打分
  matchPrepareSelected: false, // 赛前准备
  matchTimeProgressData: [], // 赛事活动设置时间轴
  matchSettingProgressData: {}, // 赛事活动设置进度
  matchMaterialAttachmentSettingFinish: false, // 赛事材料附件设置
  matchUrlHost: '', // 赛事文件地址Host
  matchOrganizers: '' // 赛事承办方
}

const mutations = {
  UPDATE_ACTIVITY_ID: (state, id) => {
    state.ActivityId = id
  },
  UPDATE_MATCH_INFO: (state, matchInfo) => {
    state.matchInfo = matchInfo
    if (matchInfo) {
      // store.dispatch('matchInfo/updateMatchInfo', matchInfo)
      // 更新基本设置信息
      let stepFirstTotalCount = 5
      let stepSecondTotalCount = 0
      let stepFirstFinishCount = 1 // 主办方为工会名称必有
      let stepSecondFinishCount = 0
      let baseSetting = state.matchInfo.matchBaseInfo
      let matchUseDefaultTheme = true
      if (!baseSetting) {
        baseSetting = {}
      }
      if (matchInfo.content) {
        baseSetting.content = matchInfo.content
        stepFirstFinishCount++
      }
      if (matchInfo.poster) {
        baseSetting.poster = matchInfo.poster
        stepFirstFinishCount++
      }
      if (matchInfo.undertaker) {
        baseSetting.undertaker = matchInfo.undertaker
        stepFirstFinishCount++
      }
      if (matchInfo.modules && matchInfo.modules.length > 0) {
        stepFirstFinishCount++
      }
      if (state.matchInfo.matchSignUpReviewSelected) {
        stepSecondTotalCount += 4
      } else {
        stepSecondTotalCount += 3
      }
      baseSetting.groups = matchInfo.groups
      baseSetting.title = matchInfo.title
      baseSetting.union = matchInfo.union
      if (matchInfo.modules) {
        state.matchBaseInfo = baseSetting
        // .dispatch('matchInfo/updateMatchBaseInfo', baseSetting)
      }
      // 更新环节设置信息
      if (matchInfo.modules) {
        state.matchLinkModuleInfo = matchInfo.modules
        // store.dispatch('matchInfo/updateMatchLinkModuleInfo', matchInfo.modules)
      }
      let matchLiveInfo = state.matchInfo.matchLiveInfo
      if (!matchLiveInfo) {
        matchLiveInfo = {}
      }
      matchLiveInfo.groups = matchInfo.groups
      matchLiveInfo.schedules = matchInfo.schedules
      if (matchInfo.modules) {
        let linkPackage = ''
        let signUpInfo = state.matchInfo.matchSignUpInfo
        let matchMaterialInfo = state.matchInfo.matchMaterialInfo
        if (!signUpInfo) {
          signUpInfo = {}
        }
        if (!matchMaterialInfo) {
          matchMaterialInfo = {}
        }
        let signupReviewSelected = false
        let materialReviewSelected = false
        for (let index in matchInfo.modules) {
          const moduleSetting = matchInfo.modules[index]
          if (linkPackage !== 'scene_materials') {
            if (
              (moduleSetting.category === 'scene' &&
                linkPackage === 'materials') ||
              (moduleSetting.category === 'materials' &&
                linkPackage === 'scene')
            ) {
              linkPackage = 'scene_materials'
            } else {
              if (
                moduleSetting.category === 'scene' ||
                moduleSetting.category === 'materials'
              ) {
                linkPackage = moduleSetting.category
              }
            }
          }
          // 报名审核
          if (
            moduleSetting.category === 'apply' &&
            moduleSetting.module === 'apply_audit'
          ) {
            if (moduleSetting.properties) {
              signUpInfo.apply_audit_start_time =
                moduleSetting.properties.apply_audit_start_time
              signUpInfo.apply_audit_end_time =
                moduleSetting.properties.apply_audit_end_time
              if (
                signUpInfo.apply_audit_start_time &&
                signUpInfo.apply_audit_end_time
              ) {
                stepSecondFinishCount++
                // console.log('报名审核 ', stepSecondFinishCount)
              }
            }

            signupReviewSelected = moduleSetting.is_selected
            continue
          }
          // 报名主题
          if (
            moduleSetting.category === 'apply' &&
            moduleSetting.module === 'theme' &&
            moduleSetting.properties.category === 'user-defined'
          ) {
            matchUseDefaultTheme = false
            if (moduleSetting.properties) {
              signUpInfo.url = moduleSetting.properties.url
              baseSetting.theme = moduleSetting.properties.url
              if (signUpInfo.url) {
                stepSecondFinishCount++
                // console.log('报名主题 ', stepSecondFinishCount)
              }
            }
            continue
          }
          // 材料上传
          if (
            moduleSetting.category === 'materials' &&
            moduleSetting.module === 'materials_upload'
          ) {
            if (moduleSetting.properties) {
              if (
                moduleSetting.properties.material_sub_start_time &&
                moduleSetting.properties.material_sub_end_time
              ) {
                stepSecondFinishCount++
                // console.log('材料上传 ', stepSecondFinishCount)
              }
              matchMaterialInfo.material_sub_start_time =
                moduleSetting.properties.material_sub_start_time
              matchMaterialInfo.material_sub_end_time =
                moduleSetting.properties.material_sub_end_time
            }
            stepSecondTotalCount += 3
            continue
          }
          // 材料打分
          if (
            moduleSetting.category === 'materials' &&
            moduleSetting.module === 'materials_score'
          ) {
            if (moduleSetting.properties) {
              if (
                moduleSetting.properties.material_score_start_time &&
                moduleSetting.properties.material_score_end_time
              ) {
                stepSecondFinishCount++
                // console.log('材料打分 ', stepSecondFinishCount)
              }
              matchMaterialInfo.material_score_start_time =
                moduleSetting.properties.material_score_start_time
              matchMaterialInfo.material_score_end_time =
                moduleSetting.properties.material_score_end_time
            }
            continue
          }
          // 材料审核
          if (
            moduleSetting.category === 'materials' &&
            moduleSetting.module === 'materials_audit'
          ) {
            if (moduleSetting.properties) {
              if (
                moduleSetting.properties.material_audit_start_time &&
                moduleSetting.properties.material_audit_end_time
              ) {
                stepSecondFinishCount++
                // console.log('材料审核 ', stepSecondFinishCount)
              }
              matchMaterialInfo.material_audit_start_time =
                moduleSetting.properties.material_audit_start_time
              matchMaterialInfo.material_audit_end_time =
                moduleSetting.properties.material_audit_end_time
            }
            stepSecondTotalCount++
            materialReviewSelected = moduleSetting.is_selected
            continue
          }
          // 现场竞赛地点设置
          if (
            moduleSetting.category === 'scene' &&
            moduleSetting.module === 'scene_contest'
          ) {
            if (moduleSetting.properties) {
              matchLiveInfo.final_addr = moduleSetting.properties.final_addr
              matchLiveInfo.final_start_time =
                moduleSetting.properties.final_start_time
              matchLiveInfo.final_end_time =
                moduleSetting.properties.final_end_time
            }
            continue
          }
          // 现场竞赛时长设置
          if (
            moduleSetting.category === 'scene' &&
            moduleSetting.module === 'scene_sequence'
          ) {
            if (moduleSetting.properties) {
              matchLiveInfo.subject_duration =
                moduleSetting.properties.subject_duration // 选手现场准备时长
              matchLiveInfo.scene_duration =
                moduleSetting.properties.scene_duration // 选手比赛时长
              matchLiveInfo.prospect_duration =
                moduleSetting.properties.prospect_duration // 选手竞赛间隔时长
            }
            continue
          }
          // 反思时长设置
          if (
            moduleSetting.category === 'summaries' &&
            moduleSetting.module === 'contest_summary'
          ) {
            if (moduleSetting.properties) {
              matchLiveInfo.duration_minutes =
                moduleSetting.properties.duration_minutes // 选手现场准备时长
            }
            continue
          }
        }
        if (linkPackage === 'scene') {
          stepSecondTotalCount += 6
        } else if (linkPackage === 'scene_materials') {
          stepSecondTotalCount += 7
          if (matchLiveInfo && matchLiveInfo.subject_duration) {
            // 选手现场准备时长
            stepSecondFinishCount++
            // console.log('选手现场准备时长 ', stepSecondFinishCount)
          }
        }
        if (matchInfo.player && matchInfo.player.length > 0) {
          // 材料附件设置是否完成
          state.materialUploadSettingList = matchInfo.player
          stepSecondFinishCount++
          // console.log('材料附件设置是否完成 ', stepSecondFinishCount)
        }
        if (matchLiveInfo) {
          // 决赛地点
          if (matchLiveInfo.final_addr) {
            stepSecondFinishCount++
            // console.log('决赛地点 ', stepSecondFinishCount)
          }
          if (matchLiveInfo.groups) {
            // 竞赛分组地点
            stepSecondFinishCount++
            // console.log('竞赛分组地点 ', stepSecondFinishCount)
            for (let index in matchLiveInfo.groups) {
              let group = matchLiveInfo.groups[index]
              if (!group || !group.site_addr) {
                stepSecondFinishCount--
                // console.log('竞赛分组地点------ ', stepSecondFinishCount)
                break
              }
            }
          }
          if (matchLiveInfo.scene_duration) {
            // 选手比赛时长
            stepSecondFinishCount++
            // console.log('选手比赛时长 ', stepSecondFinishCount)
          }
          if (matchLiveInfo.prospect_duration) {
            // 选手竞赛间隔时长
            stepSecondFinishCount++
            // console.log('选手竞赛间隔时长 ', stepSecondFinishCount)
          }
          if (matchLiveInfo.final_start_time && matchLiveInfo.final_end_time) {
            stepSecondFinishCount++
            // console.log('决赛时间地点 ', stepSecondFinishCount)
          }
          if (matchLiveInfo.schedules && matchLiveInfo.schedules.length > 0) {
            // 决赛时段设置
            stepSecondFinishCount++
            // console.log('决赛时段设置 ', stepSecondFinishCount)
            for (let index in matchLiveInfo.schedules) {
              let schedule = matchLiveInfo.schedules[index]
              if (
                !schedule ||
                !schedule.start_time ||
                !schedule.end_time ||
                !schedule.people
              ) {
                stepSecondFinishCount--
                // console.log('决赛时段设置------ ', stepSecondFinishCount)
                break
              }
            }
          }
        }
        // 更新当前环节套餐设置
        state.matchLinkPackage = linkPackage
        // 更新报名设置信息
        signUpInfo.apply_start_time = matchInfo.apply_start_time
        signUpInfo.apply_end_time = matchInfo.apply_end_time
        if (signUpInfo.apply_start_time && signUpInfo.apply_end_time) {
          stepSecondFinishCount++
          // console.log('报名时间设置 ', stepSecondFinishCount)
        }
        signUpInfo.apply_required_content = matchInfo.apply_required_content
        signUpInfo.age_limit = matchInfo.age_limit
        signUpInfo.apply_template_url = matchInfo.apply_template_url
        if (signUpInfo.apply_template_url) {
          stepSecondFinishCount++
          // console.log('报名模板 ', stepSecondFinishCount)
        }
        state.matchOrganizers = ''
        if (matchInfo.organizers && matchInfo.organizers.length > 0) {
          for (let index in matchInfo.organizers) {
            let orginazer = matchInfo.organizers[index]
            if (state.matchOrganizers !== '') {
              state.matchOrganizers += ','
            }
            state.matchOrganizers += orginazer.title
          }
        }
        let settingProgress = {
          finish: [stepFirstFinishCount, stepSecondFinishCount],
          tatal: [stepFirstTotalCount, stepSecondTotalCount]
        }
        state.matchSettingProgressData = settingProgress
        state.matchSignUpInfo = signUpInfo
        state.matchUseDefaultTheme = matchUseDefaultTheme
        // 更新材料设置信息
        state.matchMaterialInfo = matchMaterialInfo
        // 更新现场设置信息
        state.matchLiveInfo = matchLiveInfo
        state.matchSignUpReviewSelected = signupReviewSelected
        state.matchMaterialReviewSelected = materialReviewSelected
        state.matchUrlHost = matchInfo.host
      }
    }

    let linkPackage
    for (let index in state.matchInfo.modules) {
      const moduleSetting = state.matchInfo.modules[index]
      if (linkPackage !== 'scene_materials') {
        if (
          (moduleSetting.category === 'scene' && linkPackage === 'materials') ||
          (moduleSetting.category === 'materials' && linkPackage === 'scene')
        ) {
          linkPackage = 'scene_materials'
        } else {
          if (
            moduleSetting.category === 'scene' ||
            moduleSetting.category === 'materials'
          ) {
            linkPackage = moduleSetting.category
          }
        }
      }
    }
  },
  UPDATE_MATCH_PRIZE_INFO: (state, prizeInfo) => {
    state.prizeInfo = prizeInfo
  },
  UPDATE_MATCH_BASE_INFO: (state, info) => {
    state.matchBaseInfo = info
  },
  UPDATE_MATCH_LINK_MODULE_INFO: (state, info) => {
    state.matchLinkModuleInfo = info
  },
  UPDATE_MATCH_SIGNUP_INFO: (state, info) => {
    state.matchSignUpInfo = info
  },
  UPDATE_MATCH_DEFAULT_THEME_INFO: (state, isDefault) => {
    state.matchUseDefaultTheme = isDefault
  },
  UPDATE_MATCH_MATERIAL_INFO: (state, info) => {
    state.matchMaterialInfo = info
  },
  UPDATE_MATCH_MATERIAL_UPLOAD_INFO: (state, info) => {
    state.materialUploadSettingList = info
  },
  UPDATE_MATCH_MATERIAL_ATTACHMENT_INFO: (state, info) => {
    state.matchMaterialAttachmentInfo = info
  },
  UPDATE_MATCH_LIVE_INFO: (state, info) => {
    state.matchLiveInfo = info
  },
  UPDATE_MATCH_SIGNUP_REVIEW_SELECTED: (state, selected) => {
    state.matchSignUpReviewSelected = selected
  },
  UPDATE_MATCH_MATERIAL_REVIEW_SELECTED: (state, selected) => {
    state.matchMaterialReviewSelected = selected
  },
  UPDATE_MATCH_MATERIAL_SCORE_SELECTED: (state, selected) => {
    state.matchMaterialScoreSelected = selected
  },
  UPDATE_MATCH_LINK_PACKAGE: (state, linkPackage) => {
    state.matchLinkPackage = linkPackage
  },
  UPDATE_MATCH_TIME_PROGRESS_DATA: (state, data) => {
    state.matchTimeProgressData = data
  },
  UPDATE_MATCH_SETTING_PROGRESS_DATA: (state, data) => {
    state.matchSettingProgressData = data
  },
  UPDATE_MATCH_MATERIAL_ATTACHMENT_SETTING_FINISH: (state, status) => {
    state.matchMaterialAttachmentSettingFinish = status
  }
}

const actions = {
  updateActivityId ({ commit }, id) {
    commit('UPDATE_ACTIVITY_ID', id)
  },
  updateMatchInfo ({ commit }, info) {
    commit('UPDATE_MATCH_INFO', info)
  },
  updateMatchPrizeInfo ({ commit }, info) {
    commit('UPDATE_MATCH_PRIZE_INFO', info)
  },
  updateMatchBaseInfo ({ commit }, info) {
    commit('UPDATE_MATCH_BASE_INFO', info)
  },
  updateMatchLinkModuleInfo ({ commit }, info) {
    commit('UPDATE_MATCH_LINK_MODULE_INFO', info)
  },
  updateMatchSignUpInfo ({ commit }, info) {
    commit('UPDATE_MATCH_SIGNUP_INFO', info)
  },
  updateMatchDefaultThemeInfo ({ commit }, info) {
    commit('UPDATE_MATCH_DEFAULT_THEME_INFO', info)
  },
  updateMatchMaterialInfo ({ commit }, info) {
    commit('UPDATE_MATCH_MATERIAL_INFO', info)
  },
  updateMatchMaterialUploadInfo ({ commit }, info) {
    commit('UPDATE_MATCH_MATERIAL_UPLOAD_INFO', info)
  },
  updateMatchMaterialAttachmentInfo ({ commit }, info) {
    commit('UPDATE_MATCH_MATERIAL_ATTACHMENT_INFO', info)
  },
  updateMatchLiveInfo ({ commit }, info) {
    commit('UPDATE_MATCH_LIVE_INFO', info)
  },
  updateMatchSignUpReviewSelected ({ commit }, info) {
    commit('UPDATE_MATCH_SIGNUP_REVIEW_SELECTED', info)
  },
  updateMatchMaterialReviewSelected ({ commit }, info) {
    commit('UPDATE_MATCH_MATERIAL_REVIEW_SELECTED', info)
  },
  updateMatchMaterialScoreSelected ({ commit }, info) {
    commit('UPDATE_MATCH_MATERIAL_SCORE_SELECTED', info)
  },
  updateMatchLinkPackage ({ commit }, linkPackage) {
    commit('UPDATE_MATCH_LINK_PACKAGE', linkPackage)
  },
  updateMatchTimeProgressData ({ commit }, data) {
    commit('UPDATE_MATCH_TIME_PROGRESS_DATA', data)
  },
  updateMatchSettingProgressData ({ commit }, data) {
    commit('UPDATE_MATCH_SETTING_PROGRESS_DATA', data)
  },
  updateMatchMaterialAttachmentSettingFinish ({ commit }, status) {
    commit('UPDATE_MATCH_MATERIAL_ATTACHMENT_SETTING_FINISH', status)
  }
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/matchInfo.js